import {NgModule} from '@angular/core';
import {CollapsibleDirective} from './collapsible.directive';

@NgModule({
  declarations: [CollapsibleDirective],
  exports: [CollapsibleDirective],
})
export class CollapsiblesModule {}
